import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { SrxApi } from '../../api/SrxApi';
import AuthMainComponent from './AuthMainComponent';
import { UserContext } from '../../contexts/UserContext'; import '../../styles/Inputs.css';
import '../../styles/AuthMainComponent.css';

const ResetPassword = () => {
    const history = useHistory();
    const location = useLocation();
    const query = new URLSearchParams(location.search);

    const { faciToken } = useContext(UserContext);

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');

    useEffect(() => {
        const email = query.get('email');
        const token = query.get('token');
        console.log('email', email, 'token', token);
        if (faciToken) {
            history.push('/account/confirm');
        }
    }, [faciToken, location.search, history]);

    // Handle the submit action
    const handleValidSubmit = (event) => {
        event.preventDefault();
        if (password !== confirmPassword) {
            setPasswordError('Passwords do not match');
            return;
        }
        setPasswordError('');
        const resetPasswordPayload = {
            email: query.get('email'),
            token: query.get('token'),
            password,
            confirmPassword,
        };

        let resetPasswordToast = toast.loading('Loading...', {
            theme: 'light',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
        });

        // Making the API call to reset the password
        SrxApi.post('/resetPassword', resetPasswordPayload)
            .then(({ data }) => {
                console.log(data);
                history.push('/account/confirm');
                toast.update(resetPasswordToast, {
                    render: 'Password reset successfully!',
                    type: 'success',
                    isLoading: false,
                    autoClose: 3000,
                    hideProgressBar: null,
                    closeOnClick: null,
                });
            })
            .catch((err) => {
                toast.update(resetPasswordToast, {
                    render: err.response?.data?.message || 'An error occurred',
                    type: 'error',
                    isLoading: false,
                    autoClose: 3000,
                    hideProgressBar: null,
                    closeOnClick: null,
                });
            });
    };

    return (
        <>
            <AuthMainComponent title={'Reset your password'} showStar={true}>
                <form onSubmit={handleValidSubmit}>
                    <div className="form-row">
                        <input
                            className="form-input"
                            type="password"
                            name="password"
                            id="password"
                            placeholder="Enter new password"
                            onChange={(e) => {
                                const val = e.target.value;
                                setPassword(val);
                                if (confirmPassword && val !== confirmPassword)
                                    setPasswordError('Passwords do not match');
                                else setPasswordError('');
                            }}
                            value={password}
                            required
                        />
                        {passwordError && <span style={{
                            color: 'red',
                            fontSize: '12px',
                            marginTop: '10px',
                        }}>{passwordError}</span>}
                    </div>

                    <div className="form-row">
                        <input
                            className="form-input"
                            type="password"
                            name="confirm-password"
                            id="confirm-password"
                            placeholder="Confirm new password"
                            onChange={(e) => {
                                const val = e.target.value;
                                setConfirmPassword(val);
                                if (password && val !== password) setPasswordError('Passwords do not match');
                                else setPasswordError('');
                            }}
                            value={confirmPassword}
                            required
                        />
                    </div>

                    <button type="submit" className="btn-gradient" disabled={!password || !confirmPassword || !!passwordError}>
                        Reset my password
                    </button>
                </form>
            </AuthMainComponent>
        </>
    );
};

export default ResetPassword;
